(() => {
  const SELECTOR = '[data-stockists-locator]';

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initLocator = (root) => {
    if (root.dataset.stockistsReady === 'true') return;
    root.dataset.stockistsReady = 'true';

    const chips = [...root.querySelectorAll('.stockists-locator__chip')];
    const countries = [...root.querySelectorAll('.stockists-locator__country')];
    const pins = [...root.querySelectorAll('.stockists-locator__pin')];
    const places = [...root.querySelectorAll('.stockists-locator__place')];

    const pinsForCity = (city) => pins.filter((pin) => pin.dataset.city === city);
    const placesForCity = (city) => places.filter((place) => place.dataset.city === city);

    const setFilter = (value) => {
      for (const chip of chips) {
        const selected = chip.dataset.filter === value;
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', String(selected));
      }

      const visibleCities = new Set();

      for (const country of countries) {
        const visible = value === 'all' || country.dataset.country === value;
        country.classList.toggle('is-hidden', !visible);

        if (!visible) continue;

        for (const city of country.querySelectorAll('.stockists-locator__city')) {
          visibleCities.add(city.dataset.city);
        }
      }

      for (const pin of pins) {
        pin.classList.toggle('is-muted', !visibleCities.has(pin.dataset.city));
      }
    };

    const highlight = (city, state) => {
      for (const pin of pinsForCity(city)) pin.classList.toggle('is-active', state);
      for (const place of placesForCity(city)) place.classList.toggle('is-active', state);
    };

    for (const chip of chips) {
      chip.addEventListener('click', () => setFilter(chip.dataset.filter));
    }

    for (const place of places) {
      const { city } = place.dataset;
      if (!city) continue;

      place.addEventListener('mouseenter', () => highlight(city, true));
      place.addEventListener('mouseleave', () => highlight(city, false));
      place.addEventListener('focusin', () => highlight(city, true));
      place.addEventListener('focusout', () => highlight(city, false));
    }

    for (const pin of pins) {
      const { city } = pin.dataset;
      if (!city) continue;

      pin.addEventListener('mouseenter', () => highlight(city, true));
      pin.addEventListener('mouseleave', () => highlight(city, false));

      pin.addEventListener('click', (event) => {
        const target = root.querySelector(`#${CSS.escape(pin.getAttribute('href').slice(1))}`);
        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'center',
        });
        target.focus({ preventScroll: true });
        target.classList.add('is-pulsed');
        window.setTimeout(() => target.classList.remove('is-pulsed'), 1400);
      });
    }
  };

  const initAll = (scope = document) => {
    for (const root of scope.querySelectorAll(SELECTOR)) initLocator(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
